import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import Breadcrumb from 'components/consumer/consumer-breadcrumb/components/Breadcrumb';
const CustomerDashboardBreadcrumb = t0 => {
  const $ = _c(5);
  const {
    items: t1
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const items = t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      label: "Account",
      link: "/customer/dashboard/"
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== items) {
    t4 = <div className="mb-2 max-[1023px]:mt-0 max-[1023px]:mx-5 max-[1023px]:mb-2 max-[767px]:mt-0 max-[767px]:mx-3 max-[767px]:mb-2"><Breadcrumb items={[t3, ...items]} color="light" noPadding={true} /></div>;
    $[3] = items;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
};
CustomerDashboardBreadcrumb.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    link: PropTypes.string
  }))
};
export default CustomerDashboardBreadcrumb;